import { useMemo } from 'react';
import { getDisplayLines } from './CbullshitcodingMarkup';
import type { DisplayLine } from './Cbullshitcoding.typing';

interface UseCbullshitcodingDisplayLinesInput {
  loadedStrings: string[];
  propStrings?: string[];
  replacements?: Record<string, string>;
  maxDisplayLineLength?: number;
  trailingLineDropCount: number;
  trimCommonIndent: boolean;
}

export function useCbullshitcodingDisplayLines({
  loadedStrings,
  propStrings,
  replacements,
  maxDisplayLineLength,
  trailingLineDropCount,
  trimCommonIndent,
}: UseCbullshitcodingDisplayLinesInput): DisplayLine[] {
  return useMemo(
    (): DisplayLine[] =>
      getDisplayLines({
        loadedStrings,
        propStrings,
        replacements,
        maxDisplayLineLength,
        trailingLineDropCount,
        trimCommonIndent,
      }),
    [
      loadedStrings,
      maxDisplayLineLength,
      propStrings,
      replacements,
      trailingLineDropCount,
      trimCommonIndent,
    ],
  );
}
